import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import globalCss from '../../../scss/global.scss'
import { withRouter } from 'react-router-dom'
import { List, InfiniteLoader, AutoSizer } from 'react-virtualized'

export class Variations extends Component {
  constructor ({ match: { params: { itemId } } }) {
    super()
    this.state = {
      itemId,
      hasNext: false,
      itemName: '',
      instances: [],
      loading: true,
      refreshing: false,
      showModal: false,
      instanceDetails: {}
    }
    this.controller = AbortController ? new AbortController() : {}
    this.fetched = []
  }

  componentWillUnmount () {
    this.controller.abort()
  }

  componentDidMount () {
    this.getItemName(this.state.itemId).then(itemName => {
      this.setState({
        itemName: itemName
      })
      return this.getInstances()
    }).then(data => {
      const { results: instances, hasNext } = data
      this.setState({
        instances,
        hasNext,
        loading: false
      })
    })
  }

  getItemName (itemId) {
    return fetch(`/api/v1/items/${itemId}`, {
      method: 'GET',
      signal: this.controller.signal,
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        }
        return {
          _error: res.statusText
        }
      }).then(data => {
        return data.name
      })
  }

  getInstances (searchParams = '') {
    return fetch(`/api/v1/items/${this.state.itemId}/variations${searchParams}`, {
      method: 'GET',
      signal: this.controller.signal,
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      }
      return {
        _error: res.statusText
      }
    }).then(data => {
      return data
    })
  }

  getDetails = instanceId => {
    fetch(`/api/v1/items/${this.state.itemId}/variations/${instanceId}`, {
      method: 'GET',
      signal: this.controller.signal,
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    }).then(res => {
      if (res.status === 200) {
        return res.json()
      }
      return {
        _error: res.statusText
      }
    }).then(data => {
      this.setState({
        instanceDetails: data
      })
    })
  }

  view = instanceId => {
    this.openModal()
    this.getDetails(instanceId)
  }

  openModal = () => {
    this.setState({
      instanceDetails: {},
      showModal: true
    })
  }

  handleCloseModal = () => {
    this.setState({ showModal: false })
  }

  epochToString = timestamp => {
    const d = new Date(Number(timestamp))
    try {
      return d.toString().split('G')[0]
    } catch (e) {
      return 'No date'
    }
  }

  loadMoreRows = () => {
    const { instances, hasNext } = this.state
    const numInstances = instances.length
    if (!hasNext || !numInstances) {
      return
    }
    const minNumber = instances[numInstances - 1].number
    if (this.fetched.indexOf(minNumber) === -1) {
      this.fetched.push(minNumber)
      this.getInstances(`?minNumber=${minNumber}`).then(data => {
        const { results: instances, hasNext } = data
        this.setState({
          hasNext,
          instances: [...this.state.instances, ...instances],
          refreshing: false
        })
      })
    }
  };

  isRowLoaded = ({ index }) => {
    return this.state.loading && this.state.refreshing
  }

  renderRow = ({ index, key, style }) => {
    const { instances } = this.state
    const instance = instances[index]
    return (
      <div key={key} style={style} onClick={() => { this.view(instance.id) }} className={css.row}>
        <span className={css.column}>
          <small>Variation</small>
          <div>{instance.number}</div>
        </span>
        <span className={css.column}>
          <small>External ID</small>
          <div>{instance.externalId}</div>
        </span>
        <span className={css.column}>
          <small>Date</small>
          <div><small>{this.epochToString(instance.createdAt)}</small></div>
        </span>
        <span className={css.column}>
          <small>Score</small>
          <div>{instance.score}</div>
        </span>
      </div>
    )
  };

  render () {
    const { loading, refreshing, instances, showModal, instanceDetails, itemName } = this.state
    const rowCount = instances.length || 0
    let content = null
    let modal = null
    if (refreshing) {
      content = <div>Refreshing Items...</div>
    } else if (loading) {
      content = <div>Loading Items...</div>
    } else {
      content = (
        <InfiniteLoader
          isRowLoaded={this.isRowLoaded}
          loadMoreRows={this.loadMoreRows}
          rowCount={rowCount}
          threshold={4}
        >
          {({ onRowsRendered, registerChild }) => (
            <AutoSizer>
              {({ width, height }) => (
                <List
                  ref={registerChild}
                  onRowsRendered={onRowsRendered}
                  rowRenderer={this.renderRow}
                  height={height}
                  width={width}
                  rowHeight={50}
                  rowCount={rowCount}
                />
              )}
            </AutoSizer>
          )}
        </InfiniteLoader>
      )
    }

    if (showModal) {
      let details
      if (Object.keys(instanceDetails).length) {
        const { number, externalId, createdAt, score, value, context } = instanceDetails
        details = (
          <dl>
            <dt className={css.dt}>Variation Number</dt>
            <dd className={css.dd}>{number}</dd>
            <dt className={css.dt}>External ID</dt>
            <dd className={css.dd}>{externalId}</dd>
            <dt className={css.dt}>Date</dt>
            <dd className={css.dd}>{this.epochToString(createdAt)}</dd>
            <dt className={css.dt}>Score</dt>
            <dd className={css.dd}>{score}</dd>
            <dt className={css.dt}>Context</dt>
            <dd className={css.dd}>
              <pre>{JSON.stringify(context, false, 2)}</pre>
            </dd>
            <dt className={css.dt}>Value</dt>
            <dd className={css.dd}>
              <pre>{value}</pre>
            </dd>
          </dl>
        )
      } else {
        details = (<div className={css.loading}> Loading...</div>)
      }

      modal = (
        <div className={css.bg}>
          <article className={css.wrapper}>
            <header className={css.header}>
              <h3 className={css.h3}>Variation Details</h3>
              <button className={css.close} onClick={this.handleCloseModal}>
                <i className={globalCss.iconX} />
              </button>
            </header>
            <div className={css.content}>
              {details}
            </div>
          </article>
        </div>
      )
    }

    return (
      <div className={css.pageContent}>
        <h2>{itemName} Variations</h2>
        {content}
        {modal}
      </div>
    )
  }
}
const mapStateToProps = state => {
  const { auth } = state
  return {
    auth
  }
}

export default withRouter(connect(mapStateToProps)(Variations))



// WEBPACK FOOTER //
// /app/js/components/Variations/index.js